import React, { useEffect, useState } from 'react';
import { Loader2, MessageCircle, Phone, RefreshCw } from 'lucide-react';
import { phoneDigits } from './leads';
import { workflowApi } from './workflows';

export default function PhoneCheck({ value, enabled }: { value: string; enabled: boolean }) {
  const [result, setResult] = useState(''); const [status, setStatus] = useState('unknown'); const [busy, setBusy] = useState(false); const [retry, setRetry] = useState(0);
  let phone = ''; try { phone = phoneDigits(value); } catch {}
  useEffect(() => {
    let alive = true; setResult(''); setStatus('unknown'); setBusy(false);
    if (!phone || !enabled) return;
    const timer = window.setTimeout(async () => {
      setBusy(true);
      try {
        const checked = await workflowApi<{ phone: string; contactability: { status: string } }>('/whatsapp/check-draft', { phone });
        if (!alive || checked.phone !== phone) return;
        setStatus(checked.contactability.status);
        setResult(checked.contactability.status === 'available' ? 'Com WhatsApp' : 'Sem WhatsApp · salvar para ligar ou visitar');
      } catch (e) { if (alive) setResult(`Não verificado. ${(e as Error).message}`); }
      finally { if (alive) setBusy(false); }
    }, 1200);
    return () => { alive = false; window.clearTimeout(timer); };
  }, [phone, enabled, retry]);
  if (!phone || !enabled) return null;
  return <div className="prospect-phone-check" role="status">{busy ? <><Loader2 size={14} className="prospect-spin"/>Verificando WhatsApp…</> : result ? <><span className={`prospect-contact-badge ${status === 'not_found' ? 'missing' : status === 'available' ? 'available' : ''}`}>{status === 'not_found' ? <Phone size={14}/> : <MessageCircle size={14}/>} {result}</span>{status === 'unknown' && <button type="button" className="prospect-icon" title="Tentar verificar novamente" aria-label="Tentar verificar novamente" onClick={() => setRetry(n => n + 1)}><RefreshCw size={14}/></button>}</> : null}</div>;
}
